import React, { useContext } from 'react';
import usePageClassName from '../hooks/usePageClassName';
import useTranslation from '../hooks/useTranslation';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../toolkit/WithTitle';

type Props = {};

const Error404Page: React.FC<Props> = () => {
  const { t } = useTranslation();
  usePageClassName('error-page');
  const { pages } = useContext(ConfigContext);
  const title = t('pageTitles.error404');
  const Page = pages.error404.component;
  return (
    <WithTitle title={title}>
      <Page />
    </WithTitle>
  );
};
Error404Page.displayName = 'Error404Page';

export default Error404Page;
